/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// @mui material components
import Icon from '@mui/material/Icon';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

function PosShortKey({ setMenu }) {
  const { t, i18n } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const renderOpen = () => {
    return (
      <Dialog
        open={modalOpen}
        maxWidth='xs'
        keepMounted
        aria-describedby='dialog-add'
        fullWidth
        onClose={() => setModalOpen(false)}
      >
        <DialogTitle>
          Short Key
          <IconButton
            aria-label='close'
            onClick={() => setModalOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <TableContainer sx={{ boxShadow: 0 }}>
            <Table aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell align='center' width={80}>
                    KEY
                  </TableCell>
                  <TableCell align='left'>การทำงาน</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align='center'>F2</TableCell>
                  <TableCell align='left'>พิมพ์รหัส Barcode</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>p</TableCell>
                  <TableCell align='left'>เลือกสินค้า</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>w</TableCell>
                  <TableCell align='left'>รวมยอด</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>c</TableCell>
                  <TableCell align='left'>ชำระเงินสด</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>t</TableCell>
                  <TableCell align='left'>ชำระเงินโอน</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>v</TableCell>
                  <TableCell align='left'>ชำระบัตรเครดิต</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>s</TableCell>
                  <TableCell align='left'>สแกนตะกร้าสินค้า</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>Insert</TableCell>
                  <TableCell align='left'>เปลี่ยนปริมาณสินค้า</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>e</TableCell>
                  <TableCell align='left'>ลบปริมาณการซื้อ</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='center'>k</TableCell>
                  <TableCell align='left'>จัดเก็บตะกร้าสินค้า</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <>
      <MenuItem
        onClick={() => {
          setMenu(null);
          setModalOpen(true);
        }}
      >
        <Typography textAlign='center'>
          <Icon color='warning'>keyboard_alt</Icon> Short key
        </Typography>
      </MenuItem>
      {renderOpen()}
    </>
  );
}

PosShortKey.propTypes = {
  setMenu: PropTypes.func.isRequired,
};

export default PosShortKey;
